import {FC, useEffect, useRef, useState} from 'react'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {FormProvider, useForm} from 'react-hook-form'
import {Select} from '../../../../../components/UI/Select'
import {yupResolver} from '@hookform/resolvers/yup'
import Chart from 'react-apexcharts'
import {KTCard} from '../../../../../../../_metronic/helpers/components/KTCard'
import {InputRangePicker} from '../../../../../components/UI/Input/InputDatePicker'
import {schemaInspectionSearch} from '../../../../../util/validationLavanderia'
import {InspectionObservationSchemaModel} from '../../../model/report.model'
import {useLaundryFilter} from '../../../hooks/useLaundryFilter'
import {ApexOptions} from 'apexcharts'
import {
  optionsChartBar,
  optionsChartInspectionSchedule,
  optionsChartObservations,
} from '../../componentes/Charts/reports'
import {SelectOption} from '../../../../../models/utility.model'
import {
  Acumulado,
  AcumuladoCronograma,
  AcumuladoObservaciones,
  PointModel,
  SupplierModel,
} from '../../../model'
import {
  getDataDashboardMaintenanceInspection,
  getInspectionReportCSV,
  getInspectionReportPDF,
  getInspectionReportXLSX,
  getPoint,
  getSupplier,
} from '../../../services'
import {useLavanderia} from '../../../../../hooks/useLavanderia'
import {formatDateMonth} from '../../../../../util/dates'
import {ChartObservations} from '../../componentes/Charts/ChartObservations'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {donwloadFile} from '../../../helpers/utilities'

const downloadReportForType: Record<string, Record<string, any>> = {
  charts: {
    pdf: getInspectionReportPDF,
    xlsx: getInspectionReportPDF,
  },
  records: {
    pdf: getInspectionReportPDF,
    xlsx: getInspectionReportXLSX,
    csv: getInspectionReportCSV,
  },
}

export const InspectionPageWrapper: FC = () => {
  const {isAllowed} = useLavanderia()
  const [searching, setSearching] = useState(false)
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  const [isOpenDownloadMenu, setIsOpenDownloadMenu] = useState<boolean>(false)
  const [isDownload, setIsDownload] = useState<boolean>(false)
  const [hasSearchValues, setHasSearchValues] = useState<boolean>(false)
  const refWrapperDownload = useRef<HTMLDivElement>(null)
  const [showChart, setShowChart] = useState(false)
  const [chartData, setChartData] = useState<ApexOptions>(optionsChartBar)
  const [laundryPoint, setLaundryPoint] = useState<SelectOption[]>([])
  const [supplier, setSupplier] = useState<SelectOption[]>([])

  const [isSupplier, setIsSupplier] = useState<boolean>(false)
  const [isPoint, setIsPoint] = useState<boolean>(false)
  const [chartDataInspectionSchedule, setChartDataInspectionSchedule] = useState<ApexOptions>(
    optionsChartInspectionSchedule,
  )
  const [chartDataObservations, setChartDataObservations] =
    useState<ApexOptions>(optionsChartObservations)
  const [periodosAcumulados, setPeriodosAcumulados] = useState<Partial<Acumulado>>({})
  const [accumulatedCronograma, setAccumulatedCronograma] = useState<Partial<AcumuladoCronograma>>(
    {},
  )
  const [accumulatedObservations, setAccumulatedObservations] = useState<
    Partial<AcumuladoObservaciones>
  >({})

  const {
    washedOrdenStatus,
    getWashedOrderStatus,
    getClientList,
    getCompanyList,
    getSiteList,
    company,
    client,
    site,
    handleClearList,
  } = useLaundryFilter()

  const methods = useForm<InspectionObservationSchemaModel>({
    resolver: yupResolver(schemaInspectionSearch),
  })

  const handlePrint = async () => {
    window.print()
  }

  const {
    control,
    formState: {errors},
    setValue,
    handleSubmit,
    setError,
  } = methods

  const getLaundryPointList = async ({tipoAdministracion}: {tipoAdministracion: string}) => {
    let obj: PointModel = {
      isCombo: true,
      companiaId: methods.getValues('companiaId'),
      clienteId: methods.getValues('clienteId'),
      siteId: methods.getValues('siteId'),
      tipoAdministracion,
    }

    const response = await getPoint(obj, 1)
    const data = response.data.data
    const mappedLaundryPoint = data.map((item) => ({value: item.id, label: item.nombre}))

    setLaundryPoint([{value: '', label: 'TODOS'}, ...mappedLaundryPoint])
  }
  const getSupplierList = async () => {
    let obj: SupplierModel = {
      isCombo: true,
    }
    const response = await getSupplier(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.razonSocial, ...item}))
    setSupplier([{value: '', label: 'TODOS'}, ...mappedSites])
  }

  const handleFilterClient = (e: any) => {
    const {value} = e
    getClientList(value)
    setValue('companiaId', value)
    setError('companiaId', {})
  }
  const handleFilterSite = (e: any) => {
    const {value} = e
    getSiteList(value)
    setValue('clienteId', value)
    setError('clienteId', {})
  }
  const handleFilterLaundryPoint = (e: any) => {
    const {value, label} = e
    getLaundryPointList({tipoAdministracion: value})
    setValue('tipoAdministracion', value)
    setError('tipoAdministracion', {})
    setValue('puntoId', '')
    setValue('proveedorId', '')

    if (label === 'TODOS') {
      setIsPoint(true)
      setIsSupplier(true)
    } else if (value === 'COMPAÑÍA') {
      setIsSupplier(false)
      setIsPoint(true)
    } else {
      setIsPoint(false)
      setIsSupplier(true)
    }
  }

  const handleChangeDate = (rangeDate: [Date | null, Date | null]) => {
    const [newStartDate, newEndDate] = rangeDate
    setStartDate(newStartDate)
    setEndDate(newEndDate)
  }

  const createPeriodosChart = (periodos: any) => {
    const seriesCantidadInspecciones: number[] = []
    const seriesColorInspecciones: number[] = []
    const seriesPorcentajeCumplimientoPromedio: number[] = []
    const categoriesPeriodos: string[] = []

    periodos.forEach((item: any) => {
      const {cantidadInspecciones, fecha, porcentajeCumplimientoPromedio, color} = item
      seriesColorInspecciones.push(color)
      seriesCantidadInspecciones.push(parseInt(cantidadInspecciones))
      seriesPorcentajeCumplimientoPromedio.push(porcentajeCumplimientoPromedio.toFixed(2))
      categoriesPeriodos.push(fecha)
    })

    setChartData((prevState) => ({
      ...prevState,
      xaxis: {categories: categoriesPeriodos},
      colors: [
        function ({value, seriesIndex, w, dataPointIndex}: any) {
          if (seriesIndex === 0) {
            return seriesColorInspecciones[dataPointIndex]
          } else {
            return 'rgba(0,143,251,0.85)'
          }
        },
        function ({value, seriesIndex, w, dataPointIndex}: any) {
          return 'rgba(0,143,251,0.85)'
        },
      ],
      dataLabels: {
        style: {
          colors: [
            function ({value, seriesIndex, w, dataPointIndex}: any) {
              return 'black'
            },
            function ({value, seriesIndex, w, dataPointIndex}: any) {
              return 'rgba(0,143,251,0.85)'
            },
          ],
        },
      },
      series: [
        {
          name: 'Porcentaje de cumplimiento',
          type: 'column',
          data: seriesPorcentajeCumplimientoPromedio,
        },
        {
          name: 'Cantidad de Inspecciones',
          type: 'line',
          data: seriesCantidadInspecciones,
        },
      ],
    }))
  }

  const createObservationsChart = (periodos: any) => {
    const seriesCantidadAbierto: number[] = []
    const seriesCantidadCerrado: number[] = []
    const seriesCantidadAbiertoPasadoFecha: number[] = []
    const seriesCantidadCerradoPasadoFecha: number[] = []
    const categoriesPeriodos: string[] = []

    periodos.forEach((item: any) => {
      const {CantCerrado, fecha, CantAbierto, CantAbiertoPasadoFecha, CantCerradoPasadoFecha} = item
      seriesCantidadAbierto.push(CantAbierto)
      seriesCantidadCerrado.push(CantCerrado)
      seriesCantidadAbiertoPasadoFecha.push(CantAbiertoPasadoFecha)
      seriesCantidadCerradoPasadoFecha.push(CantCerradoPasadoFecha)
      categoriesPeriodos.push(fecha)
    })

    setChartDataObservations((prevState) => ({
      ...prevState,
      xaxis: {categories: categoriesPeriodos},
      series: [
        {
          name: 'Abierto',
          data: seriesCantidadAbierto,
        },
        {
          name: 'Cerrado',
          data: seriesCantidadCerrado,
        },
        {
          name: 'Abierto Pasado Fecha',
          data: seriesCantidadAbiertoPasadoFecha,
        },
        {
          name: 'Cerrado Pasado Fecha',
          data: seriesCantidadCerradoPasadoFecha,
        },
      ],
    }))
  }

  const createCronogramaChart = (periodos: any) => {
    const seriesCantidadInspeccionesProgramadas: number[] = []
    const seriesCantidadInspeccionesEjecutadas: number[] = []
    const seriesCantidadPorcentajeCumplimientoPromedio: number[] = []
    const categoriesPeriodos: string[] = []

    periodos.forEach((item: any) => {
      const {
        cantInspeccionesProgramadas,
        cantInspeccionesEjecutadas,
        fecha,
        porcentajeCumplimientoPromedio,
      } = item
      seriesCantidadInspeccionesProgramadas.push(cantInspeccionesProgramadas)
      seriesCantidadInspeccionesEjecutadas.push(cantInspeccionesEjecutadas)
      seriesCantidadPorcentajeCumplimientoPromedio.push(porcentajeCumplimientoPromedio.toFixed(2))
      categoriesPeriodos.push(fecha)
    })

    setChartDataInspectionSchedule((prevState) => ({
      ...prevState,
      xaxis: {categories: categoriesPeriodos},
      series: [
        {
          name: 'Cantidad de inspecciones programadas',
          type: 'bar',
          data: seriesCantidadInspeccionesProgramadas,
        },
        {
          name: 'Cantidad de inspecciones ejecutadas',
          type: 'bar',
          data: seriesCantidadInspeccionesEjecutadas,
        },
        {
          name: 'Porcentaje de cumplimiento promedio',
          type: 'line',
          data: seriesCantidadPorcentajeCumplimientoPromedio,
        },
      ],
    }))
  }

  const onSubmit = (dataForm: InspectionObservationSchemaModel) => {
    setSearching(true)
    const {companiaId, clienteId, siteId, puntoId, tipoAdministracion, proveedorId} = dataForm
    const data = {
      companiaId,
      clienteId,
      siteId,
      puntoId,
      proveedorId,
      tipoAdministracion,
      fechaPeriodoInicio: formatDateMonth(startDate as Date),
      fechaPeriodoFin: formatDateMonth(endDate as Date),
    }
    getDataDashboardMaintenanceInspection(data)
      .then(({data}) => {
        const {
          data: {dataCumplimiento, dataObservacion, dataCronograma},
        } = data

        const {periodos, acumulado} = dataCumplimiento
        const {periodosObservaciones, acumuladoObservaciones} = dataObservacion
        const {periodosCronograma, acumuladoCronograma} = dataCronograma
        setPeriodosAcumulados(acumulado)
        setAccumulatedCronograma(acumuladoCronograma)
        setAccumulatedObservations(acumuladoObservaciones)
        createPeriodosChart(periodos)
        createObservationsChart(periodosObservaciones)
        createCronogramaChart(periodosCronograma)
        setHasSearchValues(true)
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setSearching(false)
      })
  }
  const handleResetForm = () => {
    methods.reset()
    handleClearList()
    setStartDate(null)
    setEndDate(null)
    setHasSearchValues(false)
  }

  // download Reports for type
  const handleToggleOpenMenu = () => {
    setIsOpenDownloadMenu(!isOpenDownloadMenu)
  }
  const handleDownloadReport = async ({
    mode,
    format,
  }: {
    mode: 'records' | 'charts'
    format: 'pdf' | 'xlsx' | 'csv' | 'print'
  }) => {
    setIsDownload(true)
    setIsOpenDownloadMenu(false)
    const dataForm = methods.getValues()
    const {companiaId, clienteId, siteId, puntoId, tipoAdministracion, fechaRango} = dataForm
    // @ts-ignore
    const [startDate, endDate] = fechaRango

    if (format === 'print') {
      window.print()
      setIsDownload(false)
    } else {
      const data = {
        companiaId,
        clienteId,
        siteId,
        puntoId,
        tipoAdministracion,
        fechaPeriodoInicio: formatDateMonth(startDate as Date),
        fechaPeriodoFin: formatDateMonth(endDate as Date),
      }

      const response = await downloadReportForType[mode][format](data)
      await donwloadFile(response.data, format)
      setIsDownload(false)
    }
  }

  useEffect(() => {
    getCompanyList()
    getWashedOrderStatus('TipoAdministracion')
    setShowChart(true)
    getSupplierList()
  }, [])

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (refWrapperDownload.current && !refWrapperDownload.current.contains(event.target)) {
        setIsOpenDownloadMenu(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <KTCard shadow className='m-5'>
      {isAllowed('BUSCAR_ENCABEZADO') && (
        <div className='p-6'>
          <FormProvider {...methods}>
            <form className='m-2' onSubmit={handleSubmit(onSubmit)}>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Compañía:</label>
                  <Select
                    control={control}
                    disabled={company.length === 0}
                    name='companiaId'
                    data={company}
                    errors={errors}
                    onChangeValue={handleFilterClient}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Cliente:</label>
                  <Select
                    control={control}
                    name='clienteId'
                    data={client}
                    disabled={client.length === 0}
                    errors={errors}
                    onChangeValue={handleFilterSite}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Site:</label>
                  <Select
                    control={control}
                    name='siteId'
                    disabled={site.length === 0}
                    data={site}
                    errors={errors}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label>Fechas:</label>
                  <InputRangePicker
                    name='fechaRango'
                    errors={errors}
                    control={control}
                    placeholderText='Selecciona un rango de fechas'
                    selectsRange
                    minDate={new Date('2022-01-02')}
                    startDate={startDate}
                    endDate={endDate}
                    validateDateRange={handleChangeDate}
                    dateFormat='MM/yyyy'
                    showMonthYearPicker
                    showFullMonthYearPicker
                    showFourColumnMonthYearPicker
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label>Tipo de Administración:</label>
                  <Select
                    control={control}
                    disabled={washedOrdenStatus.length === 0}
                    name='tipoAdministracionId'
                    data={washedOrdenStatus}
                    errors={errors}
                    onChangeValue={handleFilterLaundryPoint}
                  />
                </div>
                {isPoint && (
                  <div className='col-sm-12 col-lg-3'>
                    <label>Puntos de Lavandería:</label>
                    <Select
                      control={control}
                      disabled={laundryPoint.length === 0}
                      name='puntoId'
                      data={laundryPoint}
                      errors={errors}
                    />
                  </div>
                )}
                {isSupplier && (
                  <div className='col-sm-12 col-lg-3'>
                    <label>Proveedor:</label>
                    <Select
                      control={control}
                      disabled={supplier.length === 0}
                      name='proveedorId'
                      data={supplier}
                      errors={errors}
                    />
                  </div>
                )}
              </div>
              <ButtonWrapper className='sdx-white-bg flex-column gap-3 flex-md-row d-md-flex overflow-visible justify-content-between'>
                <div className='d-flex align-items-center gap-3'>
                  <Button label='Buscar' typeBtn='submit' disabled={searching} />
                  <Button label='Limpiar' onClick={handleResetForm} />
                </div>
                <div className='d-flex align-items-center gap-3'>
                  {isAllowed('IMPRIMIR') && (
                    <Button
                      label='Imprimir'
                      typeBtn='button'
                      onClick={handlePrint}
                      disabled={searching || !hasSearchValues}
                    />
                  )}
                  {isAllowed('EXPORTAR') && (
                    <div className='position-relative' ref={refWrapperDownload}>
                      <button
                        className={`sdx_btn gap-2 ${
                          isDownload || !hasSearchValues ? 'disabledBtn' : ''
                        }`}
                        type='button'
                        disabled={isDownload || !hasSearchValues}
                        onClick={handleToggleOpenMenu}
                      >
                        {isDownload ? (
                          <div className='icon-container'>
                            <i className='loader'></i>
                          </div>
                        ) : (
                          <KTSVG
                            path='/media/icons/duotune/files/fil021.svg'
                            className='svg-icon-1'
                          />
                        )}
                        Descargar Reporte
                      </button>
                      <div
                        className='menu bg-white position-absolute end-0 z-index-3 border mt-1 menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
                        style={{display: isOpenDownloadMenu ? 'block' : 'none'}}
                      >
                        <div className='mt-4'>
                          <h4 className='px-6 fs-7 text-muted'>Registros</h4>
                          <div className='menu-item px-3'>
                            <div
                              role='button'
                              className='menu-link px-3'
                              onClick={() => handleDownloadReport({mode: 'records', format: 'pdf'})}
                            >
                              Descargar como PDF
                            </div>
                          </div>
                          <div className='menu-item px-3'>
                            <div
                              role='button'
                              className='menu-link px-3'
                              onClick={() =>
                                handleDownloadReport({mode: 'records', format: 'xlsx'})
                              }
                            >
                              Descargar como XLSX
                            </div>
                          </div>
                          <div className='menu-item px-3'>
                            <div
                              role='button'
                              className='menu-link px-3'
                              onClick={() => handleDownloadReport({mode: 'records', format: 'csv'})}
                            >
                              Descargar como CSV
                            </div>
                          </div>
                          <h4 className='px-6 fs-7 text-muted'>Gráficos</h4>
                          <div className='menu-item px-3'>
                            <div
                              role='button'
                              className='menu-link px-3'
                              onClick={() =>
                                handleDownloadReport({mode: 'records', format: 'print'})
                              }
                            >
                              Descargar como PDF
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </ButtonWrapper>
            </form>
          </FormProvider>
        </div>
      )}
      {isAllowed('LISTAR_INSPECCIONES') && (
        <div className='p-6'>
          <h2 className='fs-4 px-3'>Cumplimiento de Inspecciones</h2>
          {showChart && (
            <>
              <div className='d-flex justify-content-center gap-6 pt-4'>
                <div className='text-center'>
                  <div className='fs-3 fw-bold'>
                    {periodosAcumulados.porcentajePromedio?.toFixed(2) || 0}
                  </div>
                  <div className='fs-7 text-gray-600'>% Promedio del todo el rango</div>
                </div>
                <div className='text-center'>
                  <div className='fs-3 fw-bold'>{periodosAcumulados.cantInspecciones || 0}</div>
                  <div className='fs-7 text-gray-600'>Cant. Total de inspección de rango</div>
                </div>
              </div>
              <div className='w-100'>
                <Chart options={chartData} series={chartData.series} height={350} type='line' />
              </div>
            </>
          )}
        </div>
      )}
      {isAllowed('LISTAR_CRONOGRAMA') && (
        <div className='p-6'>
          <h2 className='fs-4 px-3'>Cumplimiento de Cronogramas de inspecciones (%)</h2>
          {showChart && (
            <>
              <div className='d-flex justify-content-center gap-6 pt-4'>
                <div className='text-center'>
                  <div className='fs-3 fw-bold'>
                    {accumulatedCronograma.cantTotalInspeccionesProgramadas || 0}
                  </div>
                  <div className='fs-7 text-gray-600'>Total trabajos programados</div>
                </div>
                <div className='text-center'>
                  <div className='fs-3 fw-bold'>
                    {accumulatedCronograma.cantTotalInspeccionesEjecutadas || 0}
                  </div>
                  <div className='fs-7 text-gray-600'>Total ejecutados</div>
                </div>
                <div className='text-center'>
                  <div className='fs-3 fw-bold'>
                    {accumulatedCronograma.cantTotalInspeccionesNoEjecutadas || 0}
                  </div>
                  <div className='fs-7 text-gray-600'>Total no ejecutados</div>
                </div>
              </div>
              <div className='d-block'>
                <Chart
                  options={chartDataInspectionSchedule}
                  series={chartDataInspectionSchedule.series}
                  height={350}
                  type='line'
                />
              </div>
            </>
          )}
        </div>
      )}
      {isAllowed('LISTAR_OBSERVACIONES') && (
        <div className='p-6'>
          <h2 className='fs-4 px-3'>Observaciones</h2>
          {showChart && (
            <>
              <div className='d-flex justify-content-center flex-wrap gap-6 pt-4'>
                <div className='text-center'>
                  <div className='fs-3 fw-bold'>
                    {accumulatedObservations.acumuladoAbierto || 0}
                  </div>
                  <div className='fs-7 text-gray-600'>Total abiertos</div>
                </div>
                <div className='text-center'>
                  <div className='fs-3 fw-bold'>
                    {accumulatedObservations.acumuladoAbiertoPasadoFecha || 0}
                  </div>
                  <div className='fs-7 text-gray-600'>Total abiertos pasado de fecha</div>
                </div>
                <div className='text-center'>
                  <div className='fs-3 fw-bold'>
                    {accumulatedObservations.acumuladoCerrado || 0}
                  </div>
                  <div className='fs-7 text-gray-600'>Total cerrados</div>
                </div>
                <div className='text-center'>
                  <div className='fs-3 fw-bold'>
                    {accumulatedObservations.acumuladoCerradoPasadoFecha || 0}
                  </div>
                  <div className='fs-7 text-gray-600'>Total cerrados pasado de fecha</div>
                </div>
              </div>
              <div className='d-block'>
                <ChartObservations chartDataObservations={chartDataObservations} />
              </div>
            </>
          )}
        </div>
      )}
    </KTCard>
  )
}
